import styles from "./Landing.module.css";
import { useMoralis } from "react-moralis";
import { setUser } from "../actions/auth";
import { Redirect } from "react-router-dom";

function Landing() {
  const { authenticate, isAuthenticated, user } = useMoralis();

  const connect = async () => {
    await authenticate();

    console.log("suer", user);

    if (isAuthenticated) {
      console.log(user);
      setUser(user);
    }
  };

  if (isAuthenticated) {
    return <Redirect to="/" />;
  }

  return (
    <div className={styles["landing-page"]}>
      <section className={styles.upper}>
        <div className={styles.img}>
          <img className={styles["img-2"]} src="/images/landing.png" />
        </div>
        <div className={styles.text}>
          <div className={styles["heading-wrapper"]}>
            <h2 className={styles.title}>Write Mon</h2>
          </div>

          <button onClick={connect} className={styles.connect}>
            Connect Wallet
          </button>
        </div>
      </section>
      <section className={styles.lower}>
        <h2 className={styles["about-heading"]}>About</h2>
        <p className={styles["about-text"]}>
          I have always wanted to make an interactive game like Pokemon , where
          we could get incentivised to write and do something productive while
          also having loads of Fun. Writemon is the experiment on Web 3, where
          you get rewarded with Writemon NFTs based on how much you write and
          how often you write. We believe Writing is an essential skill that
          acts like an invaluable tool for all modern day white collar work. We
          hope that you find this game fun and help spread the utility of web3
          to others well.
        </p>
        <p className={styles["about-text"]}>
          Write mon came together as a vision to incentivize users to learn,
          practice and enjoy writing. One of the best ways to add a layer of
          Incentives is to add NFTs based on your writing and achievement.
        </p>
        <p className={styles["about-text"]}>
          We want to expand write mon , add lots of variability in each writemon
          , Add in the Grammarly text editor API to help better reward our
          players with better rewards based on word use , grammar , originality.
          With the future being filled with AI copywriters such as GPT-3 , we
          hope to be the lighthouse that will continue to encourage
          human-writing with the help of a reward loop. We eventually hope to
          partially monetize [i.e freemium ] , by building up a larger story ,
          better quests and a NFT Marketplace [built on polygon] to make
          profits. We would also like to use Open Sea Apis to integrate without
          apps so users can directly buy or sell Writemon from their Opensea
          account.
        </p>
      </section>
    </div>
  );
}

export default Landing;
